<div class="container-fluid">
    <div class="row caja">
        <mat-radio-group [(ngModel)]="selectedFilter" (change)="cargarData()">
            <mat-radio-button value="quarter">Quarter</mat-radio-button>
            <mat-radio-button value="annual">Year</mat-radio-button>
            <!-- Agrega más opciones de radio según sea necesario -->
        </mat-radio-group>
        <mat-card class="mb-2 enrolled-created-box ccorbit-card no-scrollbar">
            <mat-card-content class="">
                <mat-tab-group (selectedTabChange)="onTabChange($event)">
                    <mat-tab label="Key Metrics">
                        <app-data-tabla [isKeymetrics]="true" [keymetrics]="keymetrics" [selectedTabFinancieros]="selectedTabFinancieros"> </app-data-tabla>
                    </mat-tab>
                    <mat-tab label="Ratios">
                        <app-data-tabla [isRatio]="true" [ratios]="ratios" [selectedTabFinancieros]="selectedTabFinancieros"> </app-data-tabla>
                    </mat-tab>
                    <mat-tab label="Casflow Growth">
                        <app-data-tabla [isCashflow]="true" [Cashflow]="Cashflow" [selectedTabFinancieros]="selectedTabFinancieros"> </app-data-tabla>
                    </mat-tab>
                    <mat-tab label="Income Growth">
                        <app-data-tabla [isIncomeGrowth]="true" [IncomeGrowth]="IncomeGrowth" [selectedTabFinancieros]="selectedTabFinancieros"> </app-data-tabla>
                    </mat-tab>
                    <mat-tab label="Balance Sheet Growth">
                        <app-data-tabla [isBalanceSheetGrowth]="true" [BalanceSheetGrowth]="BalanceSheetGrowth" [selectedTabFinancieros]="selectedTabFinancieros"> </app-data-tabla>
                    </mat-tab>
                    <mat-tab label="Financial Growth">  
                        <app-data-tabla [isFinancialGrowth]="true" [FinancialGrowth]="FinancialGrowth" [selectedTabFinancieros]="selectedTabFinancieros"> </app-data-tabla>
                    </mat-tab>

                    <mat-tab label="Owner Earnings">
                        <app-data-tabla [isOwnerEarnings]="true" [OwnerEarnings]="OwnerEarnings" [selectedTabFinancieros]="selectedTabFinancieros"> </app-data-tabla>
                    </mat-tab>
<!--                     <mat-tab label="Owner Earnings">

                    </mat-tab> -->
                    <mat-tab label="Enterprise Values">
                        <app-data-tabla [isEnterpriseValues]="true" [EnterpriseValues]="EnterpriseValues" [selectedTabFinancieros]="selectedTabFinancieros"> </app-data-tabla>
                    </mat-tab>
                </mat-tab-group>

            </mat-card-content>
        </mat-card>
    </div>
</div>